<template>
  <b-alert :show="showAlert" variant="info">
    <p v-html="alertMessage"></p>
  </b-alert>
</template>

<script>
export default {
  computed: {
    showAlert() {
      return this.alertMessage.length > 0
    },

    alertMessage() {
      return this.extractJS(this.$t('company.pricing_alert'))
    },
  },
  methods: {
    extractJS(html) {
      const regex = /(<|%3C|\\x3C)script[\s\S]*?(>|%3E|\\x3C)[\s\S]*?(<|%3C|\\x3C)(\/|%2F)script[\s\S]*?(>|%3E)/gi;
      const matches = regex.exec(html.replace('\x3C', '<').replace('\x3E', '>'));
      if(typeof matches[0] !== 'undefined')
        setTimeout(() => {
          var script = document.createElement('script')
          script.innerHTML += matches[0].replace(/(<([^>]+)>)/ig,"");
          document.body.appendChild(script);
        }, 2000);
      return html.replace(matches[0], '');
    }
  }
}
</script>
